module.exports = __webpack_public_path__ + "img/contact-main.43aec537.jpg";